export default {
  API_URL: "https://api-cms.madmax.kkv48.com/v1",
  PLAYER_URL: "https://player.madmax.kkv48.com",
};
